<template>
  <li class="page-item">
    <button type="button" class="page-link">{{ text }}</button>
  </li>
</template>

<script>
export default {
  name: "PageItem",
  props: {
    text: {
      type: [String, Number],
      required: true
    }
  }
}
</script>
